export default {
  id: 121,
  title: 'Target #121 - Duck Hunt',
  url: 'https://cssbattle.dev/play/121',
  colors: ['#1E92FF', '#6F6100', '#69D10A', '#441A0A'],
  solution:
    '<a a><a b><style>body{background:linear-gradient(#1e92ff 180px,#69d10a 180px 220px,#6f6100 220px)}a{position:fixed}[a]{top:100;left:50;width:20;height:80;background:#441a0a}[b]{top:60;left:40;width:40;height:40;background:#69d10a;color:#69d10a;border-radius:9in;box-shadow:-20px 20px,20px 20px,0 20px,270px 70px,270px 90px}</style>',
}
